import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import banner3 from '../assets/Superhero Fighting Game (1).png'
import banner from '../assets/Car Dealership Simulator.png'
import banner1 from '../assets/Horse Simulator.png'
import banner2 from '../assets/Car Parking Game.png'
import banner4 from '../assets/Highschool simulator.png'
import banner5 from '../assets/Modern Shooting Front Heroes 1.png'
import banner10 from '../assets/Grand Theft Auto 1.png'
import banner11 from '../assets/Mobile App - Fast Food 1.png'
import banner12 from '../assets/Game - Dungeon Raid 1.png'
import banner13 from '../assets/Mobile App - Gym & Fitness (2) 1.png'
import banner14 from '../assets/Banner-9 1.png'

const SliderContainer = styled.div`
  position: relative; /* Ensure karega ke navbar iske upar aaye */
  width: 100%;
  margin: auto;
  box-sizing: border-box;
`;

const SlideImage = styled.img`
  width: 100%;
  height: auto; /* Ensures the image maintains its aspect ratio */

  /* Media Queries for responsiveness */
  
  /* For larger screens like laptops */
  @media (min-width: 1024px) {
    width: 100%; /* Full width for laptops */
    height: auto;
  }

  /* For tablets */
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 100%; /* Full width for tablets */
    height: auto;
  }

  /* For mobile phones */
  @media (max-width: 767px) {
    width: 100%; /* Full width for mobiles */
    height: auto;
  }
`;

const StyledSlider = styled(Slider)`
 position: relative;
 box-sizing: border-box;
  .slick-prev, .slick-next {
    width: 70px;
    height: 70px;
    z-index: 1; // Ensure the arrows appear above the images
    /* background-color: red; */
  }

  .slick-prev {
    left: 20px;
    box-sizing: border-box;
    top: 40%;
    transform: translateY(-50%);
    @media (max-width:600px) {
top: 50%;
  }
  }

  .slick-next {
    right: 20px;
    box-sizing: border-box;
    top: 40%;
    transform: translateY(-50%);
    @media (max-width:600px) {
top: 50%;
  }
  }

  .slick-prev:before,
  .slick-next:before {
    color: #fdfbfb;
    /* background-color: green; */
    font-size: 50px;
    @media (max-width:600px) {
font-size: 30px;
  }
  }
  .slick-dots {
    position: absolute;
    bottom: 40px; /* Adjust as needed */
    width: 100%;
    display: flex !important;
    justify-content: center;
    z-index: 1; /* Ensure the dots appear above the images */
    
  }

  .slick-dots li button:before {
    color: #fcfbfb;
    /* background-color: red; */
    font-size: 12px;
    @media (max-width:600px) {
font-size: 8px;
  }
  }
  
`;
const OverlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 43%;
  background-color: rgba(255, 255, 255, 0.7);
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  z-index: 2;
  height: 60px;
  width:200px;
  font-size: larger;
  font-weight:bold ;
  color: #6e4a05;
  border-radius: 5px;
  &:hover {
    background-color: rgba(110, 74, 5, 0.7);
    color: white;
    height: 62px;
  width:202px;
  }
`;
const SlideWrapper = styled.div`
  position: relative;
`;
const OverlayLink = styled.a`
  position: absolute;
  top: 50%;
  left: 43%;
  z-index: 2;
  text-decoration: none;
`;


  const TittleImage = styled.h1`
   position: absolute;
  top: 60%;
  
  width: 400px;
  padding-top: 90px;
  margin-right: 0px;
  z-index: 3;
  align-items: center;
  text-align: center;
  color:white;
  /* background-color: red; */
  `
const ImageSlider = () => {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000, // 5 seconds
      arrows: true
    };
  const images = [
    {img:banner3, link: 'https://example.com/link1'},
    {img:banner, link: 'https://example.com/link2'},
    {img:banner1, link: 'https://example.com/link3'},
    {img:banner2, link: 'https://example.com/link4'},
    {img:banner4, link: 'https://example.com/link5'},
    {img:banner5, link: 'https://example.com/link6'},
    // {img:banner14, link: 'https://example.com/link10'},
    {img:banner10, link: 'https://example.com/link7'},
    {img:banner11, link: 'https://example.com/link8'},
    {img:banner12, link: 'https://example.com/link9'},
    {img:banner13, link: 'https://example.com/link10'},
   
  ];

  return (
    <SliderContainer>
      <StyledSlider {...settings}>
        {images.map((image, index) => (
          <SlideWrapper key={index}>
            <SlideImage src={image.img} alt={`Slide ${index + 1}`} />
            <OverlayLink href={image.link} target="_blank" rel="noopener noreferrer">
                {/* <TittleImage>{image.Tittle}</TittleImage> */}
              {/* <OverlayButton>CLICK TO PLAY</OverlayButton> */}
            </OverlayLink>
          </SlideWrapper>
        ))}
      </StyledSlider>
    </SliderContainer>
  );
};

export default ImageSlider;


